import { combineReducers } from "redux";

/* PLOP_TEMPLATE_REDUCER_IMPORT */
import Disputes from "./Disputes";
import DriverNotification from "./DriverNotification";
import DriverStories from "./DriverStories";
import DriverShelters from "./DriverShelters";
import OrderPayout from "./OrderPayout";
import LifeLine from "./LifeLine";
import FleetCoach from "./FleetCoach";
import PendingDeduction from "./PendingDeduction";
import GigsSupport from "./GigsSupport";
import Boundaries from "./Boundaries";
import DriverSupport from "./DriverSupport";
import GroomingSelfies from "./GroomingSelfies";
import Inventories from "./Inventories";
import DriverAssetIssuanceTracking from "./DriverAssetIssuanceTracking";
import Courses from "./Courses";
import Feature from "./Feature";
import FeatureToggle from "./FeatureToggle";
import User from "./User";
import Country from "./Country";
import State from "./State";
import City from "./City";
import Locality from "./Locality";
import Polygon from "./Polygon";
import TrainingStatus from "./TrainingStatus";
import MenuActions from "./MenuActions";
import DriverTags from "./DriverTags";
import CityProperty from "./CityProperty";
import GenSetting from "./GenSetting";
import Level from "./Level";
import DriverAccounting from "./DriverAccounting";
import DriverAssets from "./DriverAssets";
import DriverMedals from "./DriverMedals";
import Roles from "./Roles";
import Telecaller from "./Telecaller";
import TelecallerLeads from "./TelecallerLeads";
import DriverCashTransactions from "./DriverCashTransactions";
import AssetsIssuance from "./AssetsIssuance";
import DeliveryDrivers from "./DeliveryDrivers";
import TdsAndRiderPayoutJobs from "./TdsAndRiderPayoutJobs";
import Carriers from "./Carriers";
import ConfigChangeLog from "./ConfigChangeLog";
import TripStatistics from "./TripStatistics";
import Zone from "./Zone";
import Slots from "./Slots";
import QcDetails from "./QcDetails";
import DlRcDetails from "./DlRcDetails";
import Orders from "./Orders";
import MerchantFacade from "./MerchantFacade";
import ChatDepartments from "./ChatDepartments";
import IssueTypes from "./IssueTypes";
import SubIssueTypes from "./SubIssueTypes";
import DriverAppReleases from "./DriverAppReleases";
import CallDepartments from "./CallDepartments";
import UserProperty from "./UserProperty";
import FleetCoachDriverMapping from "./FleetCoachDriverMapping";
import RiderOffers from "./RiderOffers";
import PlatformFeeDetails from "./PlatformFeeDetails";
import FleetCoachAppReleases from "./FleetCoachAppReleases";
import CapacityChange from "./CapacityChange";
import AttributeMapping from "./AttributeMapping";
import PrizeItem from "./PrizeItem";
import Campaign from "./Campaign";
import CampaignCities from "./CampaignCities";
import Asset from "./Asset";
import RiderTdsCertificates from "./RiderTdsCertificates";
import FleetCoachTask from "./FleetCoachTask";
import FeatureConfig from "./FeatureConfig";
import RestrictedPayoutDrivers from "./RestrictedPayoutDrivers";
import CommunicationHub from "./CommunicationHub";
import DriverServices from "./DriverServices";
import DriverBanner from "./DriverBanner";

const appReducer = combineReducers({
  /* PLOP_TEMPLATE_REDUCER_INJECT */
  Disputes,
  DriverBanner,
  DriverNotification,
  DriverStories,
  FleetCoachAppReleases,
  DriverShelters,
  FleetCoachDriverMapping,
  OrderPayout,
  LifeLine,
  FleetCoach,
  PendingDeduction,
  GigsSupport,
  Boundaries,
  DriverSupport,
  GroomingSelfies,
  Inventories,
  DriverAssetIssuanceTracking,
  Courses,
  Feature,
  User,
  FeatureToggle,
  Country,
  State,
  City,
  Locality,
  Polygon,
  TrainingStatus,
  TelecallerLeads,
  MenuActions,
  DriverTags,
  DriverAssets,
  DriverMedals,
  Roles,
  DriverAccounting,
  Telecaller,
  DriverCashTransactions,
  AssetsIssuance,
  CityProperty,
  GenSetting,
  Level,
  DeliveryDrivers,
  TdsAndRiderPayoutJobs,
  Carriers,
  ConfigChangeLog,
  TripStatistics,
  Zone,
  Slots,
  QcDetails,
  DlRcDetails,
  MerchantFacade,
  DriverAppReleases,
  ChatDepartments,
  IssueTypes,
  SubIssueTypes,
  CallDepartments,
  UserProperty,
  RiderOffers,
  PlatformFeeDetails,
  CapacityChange,
  Orders,
  AttributeMapping,
  PrizeItem,
  Campaign,
  CampaignCities,
  Asset,
  RiderTdsCertificates,
  FleetCoachTask,
  FeatureConfig,
  RestrictedPayoutDrivers,
  CommunicationHub,
  DriverServices,
});

const rootReducer = (state, action) => {
  const reducersToReset = [];
  if (action.type === "RESET_TO_INITIAL") {
    Array.prototype.forEach(state, function (value, key) {
      if (Array.prototype.includes(reducersToReset, key)) {
        state[key] = undefined;
      }
    });
  }
  return appReducer(state, action);
};

export default rootReducer;
